/**
 * @generated SignedSource<<60cd09490dfbee2e568915a5e6d20250>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationBokaklippCreateScreenMutation$variables = {
  token: string;
};
export type IntegrationBokaklippCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationBokaklipp: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationBokaklippCreateScreenMutation = {
  response: IntegrationBokaklippCreateScreenMutation$data;
  variables: IntegrationBokaklippCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "concreteType": "IntegrationBokaklipp",
        "kind": "LinkedField",
        "name": "activateIntegrationBokaklipp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationBokaklippCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationBokaklippCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf4ce958ef6905128c5adaab059ab578",
    "id": null,
    "metadata": {},
    "name": "IntegrationBokaklippCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationBokaklippCreateScreenMutation(\n  $token: String!\n) {\n  store {\n    activateIntegrationBokaklipp(token: $token) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d56c9741f2a2fcc69370e091d78689e";

export default node;
